import React from 'react';
import {
  Container,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import UserManagement from './UserManagement';

const AdminPanel = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="lg" sx={{ mt: { xs: 3, sm: 4 }, mb: { xs: 3, sm: 4 } }}>
      <Typography 
        variant="h4" 
        gutterBottom
        sx={{
          fontSize: {
            xs: '1.5rem',
            sm: '1.75rem',
            md: '2rem'
          },
          fontWeight: 600,
          lineHeight: 1.3,
          mb: { xs: 2, sm: 3 }
        }}
      >
        {t('userManagement')}
      </Typography>

      <UserManagement />
    </Container>
  );
};

export default AdminPanel; 